import React, {Component} from 'react'
import hleft from '../img/hleft.png'
import hright from '../img/hright.png'
import {Map, Marker, GoogleApiWrapper} from 'google-maps-react'
import iconMarker from '../img/marker.svg' 
import * as emailjs from 'emailjs-com'

class Contacto extends Component{
    constructor(props) {
        super(props)
        this.state = {
            plantOne: hleft,
            plantTwo: hright,

            name: '',
            email: '',
            subject: '',
            message: '',
            errors: {
                name: '',
                email: '',
                subject: '',
                message: ''
            }
        }
    }

    handleInputChange(event){
        event.preventDefault()
        const target = event.target
        const name = target.name
        const value = target.value
        
        this.setState({[name]: value})
    }

    validateMail(){
        let errors = {}
        let formIsValid = true
        let txtName = document.getElementById("name")
        let txtEmail = document.getElementById("email")
        let txtPhone = document.getElementById("phone")
        let txtMessage = document.getElementById("message")
        if( !this.state.name || this.state.name.length < 3 ){
            errors.email = 'Mínimo 3 caracteres'
            txtName.classList.add('error')
            formIsValid = false
        }else{
            txtName.classList.remove('error')
        }
        if ( !this.state.subject || this.state.subject.length < 3 ) {
            errors.subject = 'Mínimo 3 caracteres'
            txtPhone.classList.add('error')
            formIsValid = false
        }else{
            txtPhone.classList.remove('error')
        }
        if( !this.state.message || this.state.message.length < 10 ){
            errors.message = 'Mínimo 3 caracteres'
            txtMessage.classList.add('error')
            formIsValid = false
        }else{
            txtMessage.classList.remove('error')
        }
        if( !this.state.email || this.state.email.length < 3 ){
            errors.email = 'Mínimo 3 caracteres'
            txtEmail.classList.add('error')
            formIsValid = false
        }else{
            txtEmail.classList.remove('error')
        }
        let pattern = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/

        if( !pattern.test(this.state.email) ) {
            errors.email = 'Email inválido'
            txtEmail.classList.add('error')
            formIsValid = false
        }else{
            txtEmail.classList.remove('error')
        }

        this.setState({
            errors: errors
        })

        return formIsValid
    }

    sentMessage(event){
        let btn = document.querySelector(".btn"),
            frm = document.querySelector("form"),
            container = document.querySelector(".w-form")
        btn.classList.add("loading")

        event.preventDefault()
        if( !this.validateMail()){
            btn.innerHTML = ''
            btn.classList.remove("loading")
            return
        }

        var templateParams = {
            from_name: this.state.name,
            from_email: this.state.email,
            to_name: "Spring's Hotel",
            subject: this.state.subject,
            message_html: this.state.message
        }
        emailjs.send('gmail','template_ghzs9xxU', templateParams, 'user_AWxDuHukGOlHQCeWX7rvf')
        .then(function (response){
            console.log('Tu mensaje ha sido enviado con éxito. Nos pondremos en contacto contigo tan pronto como pueda.')
            console.log('SUCCESS', response.status, response.text)
            btn.classList.remove("loading")
            btn.classList.add("success")
            btn.innerHTML = 'Enviado'
            setTimeout(() => {
                frm.remove()
                container.innerHTML = `
                    <form>
                        <h1>Gracias!!</h1>
                        <p>Tu mensaje ha sido enviado con éxito, 
                            nos comunicaremos contigo a la brevedad posible. 
                            Para más consultas puedes comunicarte al <b>
                            <a href="tel:+51972603177"> +51 972 603 177 </b></a>
                        </p>
                    </form>`
            }, 600);
        }, function (err){
            console.log(err)
        })

        this.setState({
            name: '',
            email: '',
            subject: '',
            message: ''
        })
    }
    
    render(){
        return (
            <div className="w-contact">
                <div className="w-form">
                    <form 
                        id={this.props.id}
                        className={this.props.className}
                        name={this.props.name}
                        method={this.props.name}
                        action={this.props.action} >     
                        <h1>Contáctanos</h1>
                        <p>Comunícate con nosotros al 
                            <a href="tel:+51972603177"> +51 972 603 177 </a>
                            con gusto atenderémos tus dudas. Nos ubicamos en Calle Los Jeranios #A16, Pichanaki 12867, Perú</p>
                        <div className="c-i">
                            <input 
                                type="text" 
                                name='name'
                                id='name'
                                required='required'
                                onChange={this.handleInputChange.bind(this)}
                                value={this.state.name}
                                error={this.state.errors.name}
                                placeholder="Nombres y Apellidos" />
                        </div>
                        <div className="c-i">
                            <input 
                                type="email" 
                                name='email'
                                id='email'
                                required='required'
                                onChange={this.handleInputChange.bind(this)}
                                value={this.state.email}
                                error={this.state.errors.email}
                                placeholder="Email" />
                        </div>
                        <div className="c-i">
                            <input 
                                tel="text" 
                                name='subject'
                                id='phone'
                                required='required'
                                onChange={this.handleInputChange.bind(this)}
                                value={this.state.subject}
                                error={this.state.errors.subject}
                                placeholder="Teléfono" />
                        </div>
                        <div className="c-i">
                            <textarea 
                                name='message'
                                id='message'
                                required='required'
                                cols="30" 
                                rows="10" 
                                onChange={this.handleInputChange.bind(this)}
                                value={this.state.message}
                                error={this.state.errors.message}
                                placeholder="Comentarios" />
                        </div>
                        <button 
                            onClick={this.sentMessage.bind(this)}
                            type='button'
                            name='submit'
                            required='required'
                            className="btn btn-secondary">
                            <span>Enviar</span>
                        </button>
                    </form>
                    <img className="plant-1" src={this.state.plantOne} alt="Spring's hotel" />
                </div>
                <p class="develop"><small>© 2019 Spring's Hotel - Todos los derechos reservados.</small></p>
                <div className="w-map">
                    <Map 
                        google={this.props.google} 
                        zoom={17}
                        initialCenter={{
                            lat: -10.9176928,
                            lng: -74.8822117
                        }}
                        defaultOptions={{
                            mapTypeControl: true
                        }}
                        styles = {
                            [{
                                "elementType": "geometry",
                                "stylers": [{
                                    "color": "#009b5b"
                                }]
                            }, {
                                "elementType": "labels.text.fill",
                                "stylers": [{}]
                            }, {
                                "elementType": "labels.text.stroke",
                                "stylers": [{
                                    "color": "#0d4c37"
                                }]
                            }, {
                                "featureType": "administrative.locality",
                                "elementType": "labels.text.fill",
                                "stylers": [{
                                    
                                }]
                            }, {
                                "featureType": "poi",
                                "elementType": "labels.text.fill",
                                "stylers": [{
                                    "color": "#ffffff"
                                }]
                            }, {
                                "featureType": "poi.business",
                                "stylers": [{
                                    "visibility": "on"
                                }]
                            }, {
                                "featureType": "poi.park",
                                "elementType": "geometry",
                                "stylers": [{
                                    "color": "#09ad69"
                                }]
                            }, {
                                "featureType": "poi.park",
                                "elementType": "labels.text",
                                "stylers": [{
                                    "visibility": "on"
                                }]
                            }, {
                                "featureType": "poi.park",
                                "elementType": "labels.text.fill",
                                "stylers": [{}]
                            }, {
                                "featureType": "road",
                                "elementType": "geometry",
                                "stylers": [{
                                    "color": "#41ca61"
                                }]
                            }, {
                                "featureType": "road",
                                "elementType": "geometry.stroke",
                                "stylers": [{}]
                            }, {
                                "featureType": "road",
                                "elementType": "labels.text.fill",
                                "stylers": [{
                                    "color": "#ffffff"
                                }]
                            }, {
                                "featureType": "road.highway",
                                "elementType": "geometry",
                                "stylers": [{
                                    "color": "#41ca61"
                                }]
                            }, {
                                "featureType": "road.highway",
                                "elementType": "geometry.stroke",
                                "stylers": [{
                                    "color": "#009b5b"
                                }]
                            }, {
                                "featureType": "road.highway",
                                "elementType": "labels.text.fill",
                                "stylers": [{
                                    "color": "#FFFFFF"
                                }]
                            }, {
                                "featureType": "transit",
                                "elementType": "geometry",
                                "stylers": [{
                                    "color": "#FFFFFF"
                                }]
                            }, {
                                "featureType": "transit.station",
                                "elementType": "labels.text.fill",
                                "stylers": [{
                                    "color": "#FFFFFF"
                                }]
                            }, {
                                "featureType": "water",
                                "elementType": "geometry",
                                "stylers": [{
                                    "color": "#009b5b"
                                }]
                            }, {
                                "featureType": "water",
                                "elementType": "labels.text.fill",
                                "stylers": [{
                                    "color": "#009f54"
                                }]
                            }, {
                                "featureType": "water",
                                "elementType": "labels.text.stroke",
                                "stylers": [{
                                    "color": "#009f54"
                                }]
                            }]
                        }
                    >
                        <Marker
                            icon={iconMarker}
                            position = {{ lat: -10.9185951, lng: -74.8851444 }}
                            scaledSize = {{ width: 30, height: 30}}
                        />
                    </Map>
                </div>
                <img className="plant-2" src={this.state.plantTwo} alt="Spring's hotel" />
            </div>
        )
    }
}

export default GoogleApiWrapper({
    apiKey: ('AIzaSyCfatyIt7gp5XVOym9x2b0VQj_DPi0CGtI')
})(Contacto)
